import { motion } from "framer-motion";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { scrollReveal } from "../Assets/Hooks/Animation";
import { useScroll } from "../Assets/Hooks/useScroll";
import Badge from "react-bootstrap/Badge";
import Img from "react-cool-img";

const myProjects = [
  {
    image: "/images/ht.jpg",
    title: "Habit Tracker",
    description:
      "Tried to Track Daily Habits, and some features - Can Add Habit - Can Check the progress - Can Update daily Status. Using React, Redux And Antd, Bootstrap For Styling - LocalStorage For Data",
    source: "https://github.com/Sachidanand9/Habit_Tracker",
    demoLink: "https://sachidanand9.github.io/Habit_Tracker/",
    badge: "ReactJS",
  },
  {
    image: "/images/pc.png",
    title: "Placement Cell",
    description:
      "Tried to replicate Placement-Cell For College Students Placement, and some features - Can Add Students/Company requirement Details - then Schedule the interview with Students",
    source: "https://github.com/Sachidanand9/Placement_Cell",
    demoLink: "https://placements-cell.herokuapp.com/",
    badge: "NodeJS",
  },
  {
    image: "/images/PL.png",
    title: "Product List",
    description:
      "You have to login then first- Can Add/Remove Product - Can Search the product. Redux for state and props management, bootstrap for styling, login using API Token also store that in sessionStorage, LocalStaorage for data",
    source: "https://github.com/Sachidanand9/Product_List",
    demoLink: "https://sachidanand9.github.io/Product_List/",
    badge: "ReactJS",
  },
  {
    image: "/images/NA.png",
    title: "NodeJS Authentication",
    description:
      "First you have to register - when click on register you will get a verification link on your entered mail id - You have to verify within 20 minutes - after verfication you can login - also you can reset your password using registered email id",
    source: "https://github.com/Sachidanand9/Nodejs-Auth",
    demoLink: "https://node-authentications.herokuapp.com/",
    badge: "NodeJS",
  },
];

const Projects = () => {
  const [element, controls] = useScroll();
  return (
    <div className="projects" id="projects">
      <motion.div
        variants={window.innerWidth > 767 ? scrollReveal : null}
        ref={element}
        animate={controls}
        className="container pt-6 pb-6"
      >
        <div className="heading-section">
          <h1>
            <span className="chonburi-font green-text">Pro</span>jects
          </h1>
        </div>
        <div className="projects-cards">
          <Row className="justify-content-center">
            {myProjects.map((project, index) => {
              return (
                <Col md={4} className="mb-5 m-5" key={index + 1}>
                  <Badge className="lmckdncd" pill variant="warning">
                    {project.badge}
                  </Badge>
                  <div className="project-card">
                    <div className="img-section">
                      <Img
                        placeholder="https://p4.wallpaperbetter.com/wallpaper/990/450/548/loading-wallpaper-preview.jpg"
                        src={project.image}
                        error="/images/download.png"
                        alt="React Cool Img"
                      />
                      <div className="imageCardEffect"></div>
                    </div>
                    <div className="project-info">
                      <h5 className="color-white font-weight-bold">
                        {project.title}
                      </h5>
                      <p className="color-white">{project.description}</p>
                      <div className="d-flex justify-content-between mr-4">
                        <a rel="noopener noreferrer"
                          href={project.source}
                          className="project-card-btn"
                          target="_blank"
                        >
                          Source Code
                        </a>
                        <a rel="noopener noreferrer"
                          href={project.demoLink}
                          className="project-card-btn"
                          target="_blank"
                        >
                          Live Demo
                        </a>
                      </div>
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      </motion.div>
    </div>
  );
};

export default Projects;
